// similar functions to SCSS mixins

import { css } from 'styled-components';

export const mediaMaxSizes = {
  sm: 743,
  md: 1023,
  lg: 1099,
};

export const mediaq = {
  sm: (...args) => css`
    @media (max-width: ${mediaMaxSizes.sm}px) {
      ${css(...args)}
    }
  `,
  md: (...args) => css`
    @media (max-width: ${mediaMaxSizes.md}px) {
      ${css(...args)}
    }
  `,
  lg: (...args) => css`
    @media (max-width: ${mediaMaxSizes.lg}px) {
      ${css(...args)}
    }
  `,
};
